import Cookies from 'js-cookie';
import Config from '../settings';
import { ESystemType } from '..';

const { TokenKey, identityKey, systemTypeKey, mockEnvSysTypeKey, authenticatekey } = Config;

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token: string, rememberMe = 0) {
  if (rememberMe) {
    Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires });
    return;
  }

  Cookies.set(TokenKey, token);
}

export function removeToken() {
  Cookies.remove(TokenKey);
  Cookies.remove(identityKey);
  Cookies.remove(systemTypeKey);
  Cookies.remove(mockEnvSysTypeKey);
}

export function updateMockEnvSysType(type: number | string) {
  Cookies.set(mockEnvSysTypeKey, String(type));
}

export function getMockEnvSysType() {
  return Cookies.get(mockEnvSysTypeKey);
}

export function updateSysType(type: string) {
  updateMockEnvSysType(type);
  Cookies.set(systemTypeKey, String(type));
}

export function getSysTypeValue() {
  return Cookies.get(systemTypeKey);
}

export function setIdentityKey(value: string) {
  Cookies.set(identityKey, value);
}

export function getIdentityKeyValue() {
  return Cookies.get(identityKey);
}

export function setAuthenticateKey(value: string) {
  Cookies.set(authenticatekey, value);
}

export function getAuthenticateKeyValue() {
  return Cookies.get(authenticatekey);
}

export function getSystemTypeFromUrl(): ESystemType | undefined {
  const regex = /\/identity-([^/]+)/;
  const match = window.location.pathname.match(regex);

  if (!match[1]) return undefined;

  const s = {
    saas: ESystemType.SAAS,
    agent: ESystemType.Agent,
    company: ESystemType.Company,
    server: ESystemType.Server,
  };

  return s[match[1]];
}
